"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var SettingUtils_1 = require("@/functions/SettingUtils");
var AppEditor_module_css_1 = __importDefault(require("./AppEditor.module.css"));
var react_i18next_1 = require("react-i18next");
var SettingsDrawerContent = function (_a) {
    var onClose = _a.onClose, appData = _a.appData;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _b = (0, react_1.useState)([]), selectedSettings = _b[0], setSelectedSettings = _b[1];
    var _c = (0, react_1.useState)({}), localValues = _c[0], setLocalValues = _c[1];
    (0, react_1.useEffect)(function () {
        var updatedSettings = Object.entries(appData.settings)
            .map(function (_a) {
            var key = _a[0], data = _a[1];
            var setting = (0, SettingUtils_1.createSettingFromData)(key, data);
            if (setting) {
                setting.order = data.order || 100;
            }
            return setting;
        })
            .filter(function (s) { return s !== undefined; })
            .sort(function (a, b) { return (a.order || 100) - (b.order || 100); });
        setSelectedSettings(updatedSettings);
        var initialValues = {};
        updatedSettings.forEach(function (setting) {
            var _a, _b;
            if (setting instanceof q_play_core_1.BooleanSetting) {
                initialValues[setting.key] = !!setting.defaultValue;
            }
            else if (setting instanceof q_play_core_1.AdvancedSelectSetting) {
                initialValues[setting.key] = (_a = setting.defaultValue) !== null && _a !== void 0 ? _a : { label: "", value: "" };
            }
            else {
                initialValues[setting.key] = ((_b = setting.defaultValue) !== null && _b !== void 0 ? _b : "");
            }
        });
        setLocalValues(initialValues);
    }, [appData.settings]);
    var handleValueChange = function (key, value) {
        setLocalValues(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = value, _a)));
        });
    };
    return (react_1.default.createElement("div", { className: AppEditor_module_css_1.default.container },
        react_1.default.createElement("div", { className: AppEditor_module_css_1.default["close-icon"], onClick: onClose, title: t("Close Settings") },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTimes, style: { color: "var(--primary-color)" } })),
        react_1.default.createElement("div", { className: AppEditor_module_css_1.default.header },
            react_1.default.createElement("p", null, t("Settings panel preview"))),
        react_1.default.createElement("div", { className: AppEditor_module_css_1.default["settings-container"] }, selectedSettings.map(function (setting) {
            var _a;
            var value = (_a = localValues[setting.key]) !== null && _a !== void 0 ? _a : (setting instanceof q_play_core_1.AdvancedSelectSetting ? { label: "", value: "" } : "");
            var settingType = (0, SettingUtils_1.getTypeString)(setting);
            var isColor = settingType === "color";
            var isAdvanced = settingType === "advanced_select";
            var dynamicKey = (isColor || isAdvanced)
                ? "".concat(setting.key, "-").concat(JSON.stringify(value))
                : setting.key;
            if (setting instanceof q_play_core_1.BooleanSetting) {
                return (react_1.default.createElement(q_play_components_1.SettingsComponent, { key: dynamicKey, value: !!value, setting: setting, disabled: false, onChange: function (e) {
                        handleValueChange(setting.key, e.target.checked);
                    } }));
            }
            return (react_1.default.createElement(q_play_components_1.SettingsComponent, { key: dynamicKey, setting: setting, value: value, disabled: false, onChange: function (e) {
                    if (setting instanceof q_play_core_1.AdvancedSelectSetting) {
                        var newValue = typeof e === "object" && "value" in e
                            ? e
                            : { label: String(e), value: String(e) };
                        handleValueChange(setting.key, newValue);
                    }
                    else if (typeof e === "object" && "target" in e) {
                        handleValueChange(setting.key, e.target.value);
                    }
                    else {
                        handleValueChange(setting.key, String(e));
                    }
                } }));
        }))));
};
exports.default = SettingsDrawerContent;
